import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Grid, Link, Typography } from '@hbf/dsl';
import { EmailActionSend } from '@hbf/icons/custom';
import { useIntl } from 'ha/i18n';

const useStyles = makeStyles()(theme => ({
  link: {
    color: theme.palette.secondary.main,
    textDecoration: 'underline',
  },
  icon: {
    marginBottom: theme.spacing(1),
  },

  title: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

export const EmailInfo: React.FC = () => {
  const { classes } = useStyles();
  const { T } = useIntl();

  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <Grid item>
        <EmailActionSend fontSize="large" className={classes.icon} />
      </Grid>
      <Grid item>
        <Typography.ParagraphTitle className={classes.title}>
          {T('contact.email_title')}
        </Typography.ParagraphTitle>
      </Grid>
      <Grid item>
        <Link
          to="mailto:support@housinganywhere.com"
          className={classes.link}
          data-test-locator="Contact Us Email"
        >
          support@housinganywhere.com
        </Link>
      </Grid>
    </Grid>
  );
};
